import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import auth from './auth';
import companies from './companies';
import currencyRates from './currency-rates';
import regions from './regions';
import packages from './packages';
import reports from './reports';
import treatmentCategories from './treatment-categories';
import warehouses from './warehouses';
import navbar from './navbar';
import invoices from './invoices';
import orderLines from './order-lines';
import orders from './orders';
import productTypes from './product-types';
import products from './products';
import profile from './profile';
import sidebar from './sidebar';
import unitTypes from './unit-types';
import users from './users';
import vessels from './vessels';
import logs from './logs';
import locations from './locations';
import subLocations from './sub-locations';
import {
  Company,
  CompanyCompanyType,
  CompanyType,
  Country,
  Currency,
  CurrencyRate,
  Invoice,
  InvoiceLine,
  Order,
  OrderLine,
  OrderLineStatus,
  OrderStatus,
  Package,
  ProductProductType,
  ProductType,
  Product,
  Region,
  TreatmentCategory,
  Status,
  StockTransaction,
  Stock,
  UnitType,
  User,
  UserGroup,
  Warehouse,
  Vessel,
  Location,
  Log,
  SubLocation,
} from './models/models';

Vue.use(Vuex);

const database = new VuexORM.Database();

database.register(Company);
database.register(CompanyCompanyType);
database.register(CompanyType);
database.register(Country);
database.register(CurrencyRate);
database.register(Currency);
database.register(Location);
database.register(SubLocation);
database.register(UnitType);
database.register(Invoice);
database.register(InvoiceLine);
database.register(Order);
database.register(OrderLine);
database.register(OrderLineStatus);
database.register(OrderStatus);
database.register(Package);
database.register(Product);
database.register(ProductProductType);
database.register(ProductType);
database.register(Region);
database.register(TreatmentCategory);
database.register(Status);
database.register(StockTransaction);
database.register(Stock);
database.register(User);
database.register(UserGroup);
database.register(Warehouse);
database.register(Vessel);
database.register(Log);

const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],
  modules: {
    auth,
    companies,
    currencyRates,
    regions,
    packages,
    warehouses,
    treatmentCategories,
    invoices,
    navbar,
    orderLines,
    orders,
    reports,
    productTypes,
    products,
    profile,
    sidebar,
    unitTypes,
    users,
    vessels,
    locations,
    subLocations,
    logs,
  },
  state: {},
  mutations: {},
  actions: {
    init({ state, dispatch }, route) {
      dispatch('auth/init', route);
      if (state.auth.isAuthenticated) {
        //  dispatch('categories/init');
        dispatch('profile/init');
        dispatch('orders/init');
        dispatch('regions/init');
        dispatch('treatmentCategories/init');
        dispatch('products/init');
        dispatch('packages/init');
        dispatch('locations/init');
        dispatch('vessels/init');
        dispatch('users/init');
        dispatch('orderLines/init');
        dispatch('unitTypes/init');
      }
    },
  },
});

export default store;
